import { fetchAuthSession, JWT } from "aws-amplify/auth";

export const getAccessToken = async (): Promise<JWT | undefined> => {
  const { accessToken } = (await fetchAuthSession()).tokens ?? {};
  return accessToken;
};
